<div class="faq-container">
  <main>
    <div class="container">
      <div class="faq-header">
        <div class="icon-container">
          <i class="material-icons icon">help_outline</i>
        </div>
        <h1>Frequently Asked Questions</h1>
        <p>
          Få svar på alle de mest spurgte spørgsmål om DUNA platformen og
          hvordan du bruger den.
        </p>
      </div>

      <div class="faq-list">
        @for (item of faqData; track item; let index = $index) {
        <div class="faq-item">
          <button
            (click)="toggleItem(index)"
            class="faq-question"
            [class.expanded]="isOpen(index)"
          >
            <h3>{{ item.question }}</h3>
            <div class="toggle-icon">
              <i class="material-icons icon">keyboard_arrow_down</i>
            </div>
          </button>
          <div class="faq-answer" [class.expanded]="isOpen(index)">
            <div class="answer-content">
              <p>{{ item.answer }}</p>
            </div>
          </div>
        </div>
        }
      </div>

      <div class="cta-section">
        <h2>Har du andre spørgsmål?</h2>
        <p>
          Vi er her for at hjælpe dig. Kontakt os, så vender vi tilbage hurtigst
          muligt.
        </p>
        <a href="/kontakt" class="cta-button">
          <i class="material-icons">mail</i>
          Kontakt os nu
        </a>
      </div>
    </div>
  </main>
</div>
